
import React from "react";
import ContactHero from "@/components/contact/ContactHero";
import ContactInfo from "@/components/contact/ContactInfo";

const Contact = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <ContactHero />
      
      {/* Contact Content */}
      <section className="py-8 bg-gradient-to-b from-white/20 to-white/40 flex-1">
        <div className="container px-4">
          <div className="max-w-2xl mx-auto">
            <ContactInfo />
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;
